/** @format */

import React from "react";
// import PropTypes from "prop-types";
import "../../styles/CustomPagination.css";
// import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import useIsMobile from "../../hooks/isMobile";

const PaginationLight = ({ pagination, isPage, onChangePage }) => {
  const isMobile = useIsMobile();
  const handleBackButtonClick = () => {
    try {
      onChangePage(isPage - 1);
    } catch (error) {
      console.log(error);
    }
  };

  const handleNextButtonClick = () => {
    try {
      if (onChangePage) {
        onChangePage(isPage + 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getPagination = () => {
    try {
      return pagination[0];
    } catch (error) {
      console.log(error);
    }
  };

  const data = getPagination();

  return (
    <div className="flex-k items-center-k js-flex-start-k w-full-k">
      <div className={`bold-text ${isMobile ? "fs-smaller-k" : ""}`}>
        Total Records: {data?.pagination || 0}
      </div>
      <div className="flex-k">
        <p
          className={`pagination-button m-0 danger ${
            isPage === 0 && "disabled-button"
          }`}
          onClick={isPage !== 0 ? handleBackButtonClick : null}
        >
          {!isMobile ? (
            // <FaArrowLeftLong size={20} />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-left"
              viewBox="0 0 16 16"
              style={{ color: "white" }}
            >
              <path
                fillRule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
              />
            </svg>
          ) : null}{" "}
          Previous {`${isMobile ? "" : "Page"}`}
        </p>
        <p
          className={`pagination-button m-0 danger ${
            isPage >= data?.pages - 1 && "disabled-button"
          }`}
          onClick={isPage < data?.pages - 1 ? handleNextButtonClick : null}
        >
          Next {`${isMobile ? "" : "Page"}`}{" "}
          {!isMobile ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-arrow-right"
              viewBox="0 0 16 16"
              style={{ color: "white" }}
            >
              <path
                fillRule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
              />
            </svg>
          ) : // <FaArrowRightLong size={20} />
          null}
        </p>
      </div>
      <span className="page-info">
        Page
        <span> {isPage ? isPage + 1 : 1}</span> of {data?.pages || 0}
      </span>
    </div>
  );
};

// PaginationLight.propTypes = {
//   pagination: PropTypes.array.isRequired,
//   isPage: PropTypes.number.isRequired,
//   onChangePage: PropTypes.func.isRequired,
// };

export default React.memo(PaginationLight);
